module.exports = __webpack_public_path__ + "static/media/cq_andamento_finanziamenti b.78f5e0d3.svg";